import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopanchganicab() {



  const cardData =
  {
    keyword: 'Mumbai to Panchgani Cab ',
    heading: 'Shambhu Cabs: Mumbai to Panchgani Cab  ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Panchgani Cab services, providing safe, comfortable, and hassle-free travel for families, friends, corporate travelers, and weekend getaway seekers heading to the scenic hill station of Panchgani. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Panchgani with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip stress-free and convenient. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Panchgani cab services for travelers seeking comfort, safety, and a memorable travel experience.',

    top: 'Top Places to Visit in Panchgani with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Table Land",
    "description": "Table Land is a vast, flat plateau at an altitude of over 1,300 meters, making it one of the highest points in Panchgani. Famous for its panoramic views of the surrounding valleys and hills, it is a popular spot for horse riding, trekking, and photography. The plateau also offers mesmerizing sunsets, making it ideal for nature enthusiasts and adventure seekers."
  },
  {
    "title": "Panchgani Sunset Point",
    "description": "Panchgani Sunset Point provides a breathtaking view of the sun setting behind the Western Ghats. The vantage point is perfect for evening walks, photography, and enjoying the cool hill-station breeze. The surrounding hills and valleys create a serene atmosphere, ideal for relaxation and quiet reflection."
  },
  {
    "title": "Devil’s Kitchen",
    "description": "Devil’s Kitchen is a narrow canyon with rugged cliffs, giving it a dramatic and adventurous appeal. Visitors often trek through the rocky paths, exploring the unique geological formations. The site is also associated with local folklore, adding a mysterious charm to the natural landscape."
  },
  {
    "title": "Sydney Point",
    "description": "Sydney Point is a scenic viewpoint offering panoramic views of Krishna Valley and the Dhom Dam backwaters. Early morning visits are recommended for witnessing misty valleys and lush greenery. It is a quiet spot perfect for nature walks, meditation, and photography."
  },
  {
    "title": "Krishna Valley Viewpoint",
    "description": "The Krishna Valley Viewpoint provides stunning views of the Krishna River as it winds through the valleys below. The viewpoint is surrounded by dense forests and rolling hills, making it ideal for picnics, nature photography, and observing the scenic beauty of Panchgani."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a famous attraction in Panchgani, known for its strawberry farms, fruit preserves, and fresh jams. Visitors can enjoy farm tours, tasting sessions, and explore the cafe that serves delicious strawberry-based desserts. It’s a perfect destination for families and food lovers."
  },
  {
    "title": "Parsi Point",
    "description": "Parsi Point is a popular viewpoint offering breathtaking vistas of the Dhom Dam and surrounding valleys. Named after the Parsi community who frequented the area, it is ideal for evening outings, nature photography, and enjoying the cool climate of Panchgani."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a scenic waterfall near Panchgani, cascading from a height of over 600 feet. The waterfall is surrounded by lush greenery and is especially spectacular during the monsoon season. Visitors can enjoy trekking, nature walks, and photography at this serene spot."
  },
  {
    "title": "Rajpuri Caves",
    "description": "Rajpuri Caves are a cluster of ancient caves situated on the hills around Panchgani. These caves are believed to have historical and religious significance, offering trekking enthusiasts a combination of adventure, exploration, and cultural insight."
  },
  {
    "title": "Panchgani Market",
    "description": "Panchgani Market is a bustling area where visitors can shop for local handicrafts, fresh fruits, strawberries, and souvenirs. The market is lively, colorful, and a great place to interact with locals while experiencing the cultural vibe of this charming hill station."
  }
],

"services": [
  {
    "name": "Mumbai Panchgani Taxi",
    "description": "Mumbai Panchgani Taxi offers reliable and comfortable transportation from Mumbai to Panchgani. With professional drivers, well-maintained vehicles, and timely pickups, this service ensures a hassle-free journey. Ideal for family trips, weekend getaways, and leisure travel, passengers can enjoy a smooth ride along scenic routes with safety and convenience prioritized."
  },
  {
    "name": "Panchgani Trip Cab Mumbai",
    "description": "Panchgani Trip Cab Mumbai provides a dedicated cab service for travelers planning trips to Panchgani. Offering spacious sedans and SUVs, professional drivers, and flexible booking options, this service is perfect for sightseeing, weekend trips, or corporate travel from Mumbai."
  },
  {
    "name": "One-Way Cab Mumbai Panchgani",
    "description": "One-Way Cab Mumbai Panchgani is designed for travelers who need a single-drop service without a return journey. Perfect for short trips, personal visits, or business travel, this service ensures economical pricing, comfortable vehicles, and professional drivers for a smooth ride to Panchgani."
  },
  {
    "name": "Affordable Cab Mumbai Panchgani",
    "description": "Affordable Cab Mumbai Panchgani offers budget-friendly travel options without compromising comfort or safety. Ideal for solo travelers, students, and small families, this service ensures a reliable and economical way to reach Panchgani from Mumbai."
  },
  {
    "name": "Best Taxi Mumbai Panchgani",
    "description": "Best Taxi Mumbai Panchgani is known for high-quality vehicles, punctual service, and professional drivers. Passengers can enjoy a stress-free journey, comfortable seating, and safe driving, making it a preferred choice for leisure trips, family outings, and corporate travel."
  },
  {
    "name": "SUV Cab Panchgani",
    "description": "SUV Cab Panchgani caters to families or groups traveling together, offering spacious and comfortable vehicles for long-distance trips. Equipped with modern amenities and safety features, these SUVs provide a smooth ride and ample luggage space for extended journeys."
  },
  {
    "name": "Sedan Cab Mumbai Panchgani",
    "description": "Sedan Cab Mumbai Panchgani provides elegant and efficient sedans for travelers seeking comfort and economy. With experienced drivers and well-maintained vehicles, passengers enjoy a smooth and relaxed ride from Mumbai to Panchgani, suitable for couples, small families, and business travelers."
  },
  {
    "name": "24×7 Mumbai Panchgani Cab",
    "description": "24×7 Mumbai Panchgani Cab ensures round-the-clock availability for travelers needing intercity transport to Panchgani. With flexible timings, on-demand booking, and professional drivers, this service guarantees convenience and safety at any time of day or night."
  },
  {
    "name": "Outstation Cab Mumbai Panchgani",
    "description": "Outstation Cab Mumbai Panchgani specializes in long-distance travel, providing well-maintained vehicles and experienced drivers for a safe and comfortable journey. Ideal for extended trips, sightseeing, or corporate travel, this service ensures a seamless travel experience."
  },
  {
    "name": "Family Trip Cab Panchgani",
    "description": "Family Trip Cab Panchgani offers spacious and comfortable vehicles for group or family travel. With professional drivers, safety features, and scenic route knowledge, this service provides an enjoyable and relaxed travel experience from Mumbai to Panchgani."
  },
  {
    "name": "Corporate Cab Mumbai Panchgani",
    "description": "Corporate Cab Mumbai Panchgani caters to business travelers, offering premium vehicles and professional chauffeur-driven service. Punctuality, comfort, and reliability are ensured for meetings, corporate trips, or client visits between Mumbai and Panchgani."
  },
  {
    "name": "Premium Cab Panchgani Mumbai",
    "description": "Premium Cab Panchgani Mumbai provides luxury vehicles and high-end services for travelers seeking maximum comfort and style. With experienced chauffeurs, well-maintained cars, and a focus on safety, this service ensures an elegant and stress-free journey."
  },
  {
    "name": "Express Highway Cab Panchgani",
    "description": "Express Highway Cab Panchgani offers fast and efficient travel via highways, reducing travel time while maintaining passenger comfort and safety. Perfect for travelers who want a quick and smooth road trip experience from Mumbai."
  },
  {
    "name": "Fast Cab Mumbai Panchgani",
    "description": "Fast Cab Mumbai Panchgani provides time-efficient travel for those on a tight schedule. With direct routes, professional drivers, and well-maintained vehicles, this service ensures a smooth and speedy journey to Panchgani without compromising safety."
  },
  {
    "name": "Safe Taxi Mumbai Panchgani",
    "description": "Safe Taxi Mumbai Panchgani prioritizes passenger safety with trained drivers, regular vehicle maintenance, and adherence to all safety protocols. Suitable for solo travelers, families, and corporate clients, this service offers a secure and reliable journey from Mumbai to Panchgani."
  },
  {
    "name": "Mumbai Panchgani Pickup Drop",
    "description": "Mumbai Panchgani Pickup Drop offers door-to-door service for maximum convenience. With professional drivers, comfortable vehicles, and flexible scheduling, passengers enjoy a seamless and stress-free journey between Mumbai and Panchgani."
  },
  {
    "name": "Mumbai Mahabaleshwar Panchgani Cab",
    "description": "Mumbai Mahabaleshwar Panchgani Cab provides combined trips covering Mahabaleshwar and Panchgani. Perfect for tourists and weekend travelers, this service offers well-maintained vehicles, professional drivers, scenic route knowledge, and convenient scheduling for an enjoyable long-distance journey."
  }
],

"tableData": [
  ["Mumbai Panchgani Taxi", "Panchgani Trip Cab Mumbai"],
  ["One-Way Cab Mumbai Panchgani", "Affordable Cab Mumbai Panchgani"],
  ["Best Taxi Mumbai Panchgani", "SUV Cab Panchgani"],
  ["Sedan Cab Mumbai Panchgani", "24×7 Mumbai Panchgani Cab"],
  ["Outstation Cab Mumbai Panchgani", "Family Trip Cab Panchgani"],
  ["Corporate Cab Mumbai Panchgani", "Premium Cab Panchgani Mumbai"],
  ["Express Highway Cab Panchgani", "Fast Cab Mumbai Panchgani"],
  ["Safe Taxi Mumbai Panchgani", "Mumbai Panchgani Pickup Drop"],
  ["Mumbai Mahabaleshwar Panchgani Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Panchgani Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Panchgani cab services, perfect for weekend getaways, hill station trips, and leisure travel amidst scenic landscapes."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a smooth and comfortable journey to Panchgani."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Ghat and Hill Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with the Mumbai to Panchgani ghat and hill routes, ensuring safe, timely, and comfortable travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront and clear pricing—fuel, tolls, and driver allowances included—making your Mumbai to Panchgani cab trip hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, travel queries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Hill Station Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Panchgani travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Mumbai to Panchgani journey stress-free and comfortable."
  }
]
























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Panchgani cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Panchgani cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Panchgani cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Panchgani cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for a safe and comfortable trip from Mumbai to Panchgani.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Panchgani route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Mumbai to Panchgani route to ensure a smooth and safe journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Panchgani cab?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off location anywhere in Panchgani.',
  },
  {
    question: 'Is the Mumbai to Panchgani cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Panchgani cab booking services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Panchgani cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Panchgani cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Panchgani journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Panchgani travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'Our Mumbai to Panchgani trip with Shambhu Cabs was comfortable and hassle-free. The driver was professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Highly reliable Mumbai to Panchgani cab service. Smooth journey, clean car, and excellent support from Shambhu Cabs.',
    rating: 5,
  },
];
















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Panchgani Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-panchgani-cab.jpg",
  "description": "Shambhu Cabs provides safe and comfortable Mumbai to Panchgani cab services for one-way or round trips. Perfect for family outings, corporate travel, and hill station visits including Panchgani and Mahabaleshwar. Choose from sedans, SUVs, and premium cars with professional drivers and 24×7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-panchgani-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Panchgani Cab | Hill Station & Outstation Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Panchgani cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for family trips, corporate travel, and hill station visits including Panchgani and Mahabaleshwar. Available 24×7 with sedan, SUV, and premium cars."
  />

  <meta
    name="keywords"
    content="Mumbai Panchgani Taxi, Panchgani Trip Cab Mumbai, One-Way Cab Mumbai Panchgani, Affordable Cab Mumbai Panchgani, Best Taxi Mumbai Panchgani, SUV Cab Panchgani, Sedan Cab Mumbai Panchgani, 24×7 Mumbai Panchgani Cab, Outstation Cab Mumbai Panchgani, Family Trip Cab Panchgani, Corporate Cab Mumbai Panchgani, Premium Cab Panchgani Mumbai, Express Highway Cab Panchgani, Fast Cab Mumbai Panchgani, Safe Taxi Mumbai Panchgani, Mumbai Panchgani Pickup Drop, Mumbai Mahabaleshwar Panchgani Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopanchganicab;